export const environment = {
    backendUrl: "https://fitt-backend.ennova-research.com",
};
